import { useState, useEffect } from 'react';
import FormControl from '@mui/material/FormControl';
import Assignment from '@mui/icons-material/Assignment';
import QrCodeIcon from '@mui/icons-material/QrCode';
import HighlightOff from '@mui/icons-material/HighlightOff';
import AttachMoney from '@mui/icons-material/AttachMoney';
import { useForm } from 'react-hook-form';
import LoadingButton from '../../@iosper/components/LoadingButton';
import CustomizedSnackbars from '../Notifications/SnackBar';
import { useUser } from '../Auth/User';
import { useParams } from 'react-router-dom';
import ButtonBack from '../Breadcrumb/ButtonBack';
import { Share as ShareIcon } from '@mui/icons-material';
import CountDown from '../Common/CountDown';
import { QRCodeSVG } from 'qrcode.react';
import {
  Alert,
  Box,
  Card,
  CardActions,
  CardContent,
  DialogActions,
  DialogContent,
  DialogContentText,
  CardHeader,
  Container,
  Divider,
  Grid,
  ListItemText,
  Skeleton,
  Typography,
  Button, 
  Stack,
  Fade,
} from '@mui/material';
import logo from '../../assets/images/logo-small.png';
import { formatDateTime, formatearFecha } from '../../@iosper/utils/Format';
import { SUCCESS, WARNING } from '../../@iosper/components/LoadingButton/LoadingAlert';
import TokenFarmaciaQRMessageEvent from './TokenFarmaciaQRMessageEvent';

import AfiliadoSelect from '../Afiliados/AfiliadoSelect';
import { generarTokenFarmacia } from '../../services/Afiliado/Farmacia';
import TokenFarmaciaQr from './TokenFarmaciaQr';

const GenerarTokenFarmacia = () => {
  let { idAfiliado } = useParams();
  const [afiliado, setAfiliado] = useState(null);
  const [selectedAfiliado, setSelectedAfiliado] = useState(null);
  const [keyComponentAfiliado, setKeyComponentAfiliado] = useState(0);
  const [loadingToken, setloadingToken] = useState(false);
  const [tokenActual, setTokenActual] = useState(null);
  const [caducado, setCaducado] = useState(false);
  const [fechaCreacionToken, setFechaCreacionToken] = useState(null);
  // Dialog Orden QR Preview
  const [openQRPreview, setOpenQRPreview] = useState(false);
  const [socket, setSocket] = useState(null);
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onBlur' });

  
  // Dialog QR Messages Event Preview
  const [messageQr, setMessageQr] = useState('');
  const [qrMessageEventOpen, setQrMessageEventOpen] = useState(false);
  const [qrMessageEventStatus, setQrMessageEventStatus] = useState();

  const { user } = useUser();

  useEffect(() => {
    if (socket != null) {
      socket.onmessage = function (e) {
        const mssg = JSON.parse(e.data);
        if (mssg.token === tokenActual) {
          switch (mssg.state) {
            case 'ErrorValidacionQrFarmacia': {
              setOpenQRPreview(false);
              setQrMessageEventOpen(true);
              setQrMessageEventStatus(WARNING);
              setMessageQr(mssg.message);
              socket.close();
              break;
            }
            case 'QrFarmaciaValidado': {
              
              setOpenQRPreview(false);
              setQrMessageEventOpen(true);
              setQrMessageEventStatus(SUCCESS);
              setMessageQr(mssg.message);
              socket.close();
              break;
            }
            default:
              socket.close();
                        }
        }
      };
    }
  }, [socket]);

  const handlerLimpiar = () => {
    
    reset();
   // setSelectedAfiliado(null);
    setTokenActual(null);
    setCaducado(false);
    setFechaCreacionToken(null);
    setloadingToken(false);
    //socket.close();
  }

  const handlerCerrarPreview = () => {
    handlerLimpiar();
  };
  
  const onSubmit = async (data, event) => {
    setloadingToken(true);
    event.preventDefault();
    if(selectedAfiliado) {

      try {
        const getToken = await generarTokenFarmacia(selectedAfiliado.afiliado.idAfiliado);
        if (getToken) {
          setTokenActual(getToken); 
          //(getToken.fechaCreacion);
          setloadingToken(false);
          setOpenQRPreview(true);
   
          conectarWebSocket(getToken);
    
        } 
      } catch (e) {
        setloadingToken(false);
      }
    }

   
  };
   
  const handleGenerateQR = async () => {
    if(selectedAfiliado) {
      setloadingToken(true);
      const getToken = await generarTokenFarmacia(selectedAfiliado.afiliado.idAfiliado);
      if (getToken) {
        setTokenActual(getToken); 
        setloadingToken(false);
        conectarWebSocket(getToken);
      }
  }
  };

  const validateAfiliado = () => {
    return selectedAfiliado == null ? false : true;
  };

  const onSelectAfiliado = (afiliado) => {
    setSelectedAfiliado(afiliado);
  };

  const onCaducado = () => {
    setCaducado(true);
    setFechaCreacionToken(null);
    alert("caducado");
  };
  

  const onReload = (value) => {
    handleGenerateQR();
    setCaducado(false);
    setTokenActual(null);
  };


  const conectarWebSocket = (qrValue) => {
   setSocket(
      new WebSocket(
        `${process.env.REACT_APP_WEBSOCKET_URL}?tokenQr=${qrValue}&token=${localStorage.getItem(
          'token',
        )}`,
      ),
    );
  };


  const DrawerDataField = ({ label, data, loading = false, style = {} }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: 0, sm: 1 },
        alignItems: 'baseline',
        width: '100%',
      }}
    >
      {loading && (
        <Skeleton
          variant='text'
          sx={{ fontSize: '1.9rem', width: { xs: 230, sm: 380 }, ...style }}
        />
      )}
      {!loading && (
        <>
          <Typography variant='body' fontWeight={700}>
            {label}
          </Typography>
          <ListItemText primary={data} />
        </>
      )}
    </Box>
  );
};

const handlerCerrarQRPreview = () => {
  setOpenQRPreview(false);
  handlerLimpiar();
};

const handlerCerrarQRMessageEvent = () => {
  setQrMessageEventOpen(false);
  handlerLimpiar();
};

  return (
    // <Container component={'main'} maxWidth='md' sx={{ display: 'flex', justifyContent: 'center' }}>
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card sx={{ width: '100%', p: 1 }}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <CardContent>
              <FormControl fullWidth={true} variant='outlined' margin='normal'>
                <AfiliadoSelect
                  key={keyComponentAfiliado}
                  ref={register('afiliadoRegister', {
                    validate: validateAfiliado,
                  })}
                  onSelectAfiliado={onSelectAfiliado}
                  onDefaultAfiliado={idAfiliado}
                />
                {errors.afiliadoRegister && (
                  <p style={{ color: 'red' }}>Debe seleccionar el afiliado</p>
                )}
              </FormControl>
            </CardContent>
            <CardActions sx={{ justifyContent: 'flex-end', p: 2 }}>
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={{ xs: 1, sm: 2 }}
                justifyContent={{ xs: 'center', sm: 'flex-end' }}
                alignItems={{ xs: 'strech' }}
              > 
                <LoadingButton
                  fullWidth={true}
                  variant='contained'
                  size='medium'
                  color='primary'
                  startIcon={<QrCodeIcon />}
                  type='submit'
                  loading={loadingToken ? 'show' : 'hide'}
                  content={'Generar'}
                />
              </Stack>
            </CardActions>
          </form>

        {/* QR */}
        <TokenFarmaciaQr
          open={openQRPreview}
          setOpen={openQRPreview}
          qrValue={tokenActual}
          afiliado={selectedAfiliado}
          handlerCerrarPreview={handlerCerrarQRPreview}
        ></TokenFarmaciaQr>
         {/* Messages */}
        <TokenFarmaciaQRMessageEvent
          open={qrMessageEventOpen}
          message={messageQr}
          status={qrMessageEventStatus}
          onHandleCerrar={handlerCerrarQRMessageEvent}
        ></TokenFarmaciaQRMessageEvent>        
        </Card>
      </Grid>      
    </Grid>    
  ); 
};

export default GenerarTokenFarmacia;